import { jsx as l } from "react/jsx-runtime";
const n = (o) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...o,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "m42.348 54.174 2.547-32.011h-9.178l.66-4.213 7.913-9.361-1.527-1.292-8.276 9.79-.794 5.076H22.804a4.554 4.554 0 0 0-4.54 4.915l2.22 27.878a4.696 4.696 0 0 0 4.68 4.323H39.31l-1.072-4H25.165a.7.7 0 0 1-.694-.64l-1.925-24.191h17.678l-1.976 24.825 4.1-1.099ZM22.387 28.448l-.135-1.687a.534.534 0 0 1 .146-.42.534.534 0 0 1 .406-.178h17.76l-.181 2.285H22.386Z"
      }
    )
  }
);
export {
  n as Drink
};
